var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIconSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66103 1.6499H6.41103V1.8999V6.91054H1.40039H1.15039V7.16054V7.83927V8.08927H1.40039H6.41103V13.0999V13.3499H6.66103H7.33976H7.58976V13.0999V8.08927H12.6004H12.8504V7.83927V7.16054V6.91054H12.6004H7.58976V1.8999V1.6499H7.33976H6.66103Z",
    fill: "#354EB4",
    stroke: "#354EB4",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconSecondary);
export default __webpack_public_path__ + "static/media/add-icon-secondary.2bfe7d1dda25583f9a756ce1f3edb240.svg";
export { ForwardRef as ReactComponent };